import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { GrPowerReset } from "react-icons/gr";
import { IoIosCloseCircle } from "react-icons/io";
import { Oval } from "react-loader-spinner";
import BoxAlert from "../../../../components/boxAlert/index.jsx";
import { formatInputCurrencyValues } from '../../../../scripts/formatInputCurrencyValues';
import formatValues from "../../../../scripts/formatValues";
import { getAddressInformations } from "../../../../scripts/getAddressInformations";
import normalizeValues from "../../../../scripts/normalizeValues";
import axios from "../../../../services/axios-config";
import styles from "./css/editData.module.css";
import { InputMask } from "@react-input/mask";

// MAPEIA CADA CRT AO TEXTO DE REGIME TRIBUTÁRIO (rt) CORRESPONDENTE, PARA QUE OS DOIS
// NUNCA FIQUEM DESSINCRONIZADOS (MESMO CRITÉRIO USADO EM app/src/config/constantsFiscal.js)
const CRT_TO_RT = {
  '1': 'Simples Nacional',
  '2': 'Simples Nacional',
  '3': 'Regime Normal',
  '4': 'MEI',
};



export default function EditData (props) {

    // VARIÁVEIS DE EDIÇÃO ===============================>

    const [editNomeFantasia, setEditNomeFantasia] = useState(null);
    const [editRazaoSocial, setEditRazaoSocial] = useState(null);
    const [editCompanyDocument, setEditCompanyDocument] = useState(null);
    const [editCompanyEmail, setEditCompanyEmail] = useState(null);
    const [editCompanyPhone, setEditCompanyPhone] = useState(null);

    const [editNfeNumber, setEditNfeNumber] = useState(null);
    const [editNfceNumber, setEditNfceNumber] = useState(null);
    const [editIssueSeries, setEditIssueSeries] = useState(null);
    const [editStateRegistration, setEditStateRegistration] = useState(null);
    const [editEmissionEnv, setEditEmissionEnv] = useState('2');
    const [editCrt, setEditCrt] = useState('1');
    const [editIcms, setEditIcms] = useState(null);

    const [editCompanyCep, setEditCompanyCep] = useState(null);
    const [editCompanyState, setEditCompanyState] = useState(null);
    const [editCompanyCity, setEditCompanyCity] = useState(null);
    const [editCompanyStreet, setEditCompanyStreet] = useState(null);
    const [editCompanyDistrict, setEditCompanyDistrict] = useState(null);
    const [editCompanyNumber, setEditCompanyNumber] = useState(null);
    const [editCompanyComplement, setEditCompanyComplement] = useState(null);
    const [editPaymentPrice, setEditPaymentPrice] = useState(null);
    const [editPaymentDay, setEditPaymentDay] = useState(null);
    const [editNextPayment, setEditNextPayment] = useState(null);
    const [editLatitude, setEditLatitude] = useState(null);
    const [editLongitude, setEditLongitude] = useState(null);
    const [editRadius, setEditRadius] = useState(null);

    const [checkPrintNfe, setCheckPrintNfe] = useState(false);
    const [checkUseSmartmenu, setCheckUseSmartmenu] = useState(false);
    const [checkUseIfood, setCheckUseIfood] = useState(false);
    const [checkUseStock, setCheckUseStock] = useState(false);


    // LOADING CONTROLLER
    const [loading, setLoading] = useState(false);
    const [searchingCep, setSearchingCep] = useState(false);


    // ALERTS CONTROLLER
    const [warnAlert, setWarnAlert] = useState({show: false, title: null, text: null});




    // FUNCTIONS ===========================>

    // CONVERTE UMA DATA PARA O FORMATO ACEITO PELO INPUT TYPE="DATE" (YYYY-MM-DD)
    const toDateInputValue = (value) => {
      if (!value) return '';

      const parsed = new Date(value);

      if (Number.isNaN(parsed.getTime())) return '';

      return parsed.toISOString().slice(0, 10);
    }

    useEffect(() => {
        if(props.data){
          handleSetEditValues()
        }
    }, [props.data])



    const handleSetEditValues = () => {
      const {name, razao_social, document, email, phone, fiscal, address, payment_control, privileges} = props?.data;

      setEditNomeFantasia(name);
      setEditRazaoSocial(razao_social);
      setEditCompanyDocument(document);
      setEditCompanyEmail(email);
      setEditCompanyPhone(phone);

      setEditNfeNumber(fiscal?.nfe_number);
      setEditNfceNumber(fiscal?.nfce_number);
      setEditIssueSeries(fiscal?.issue_series);
      setEditStateRegistration(fiscal?.state_registration);
      setEditEmissionEnv(String(fiscal?.emission_env ?? '2'));
      setEditCrt(String(fiscal?.crt ?? '1'));
      setEditIcms(fiscal?.icms ?? '');

      setEditCompanyCep(address?.cep);
      setEditCompanyState(address?.state);
      setEditCompanyCity(address?.city);
      setEditCompanyStreet(address?.street);
      setEditCompanyDistrict(address?.district);
      setEditCompanyNumber(address?.number);
      setEditCompanyComplement(address?.complement ?? '');
      setEditLatitude(address?.latitude);
      setEditLongitude(address?.longitude);
      setEditRadius(address?.radius);

      setEditPaymentPrice(formatValues(payment_control?.cost ?? '00'));
      setEditPaymentDay(payment_control?.payday);
      setEditNextPayment(toDateInputValue(payment_control?.next_payment));

      setCheckPrintNfe(privileges?.use_invoice);
      setCheckUseSmartmenu(privileges?.use_smartmenu ? true : false);
      setCheckUseIfood(privileges?.use_ifood ? true : false);
      setCheckUseStock(privileges?.use_stock ? true : false);
    }


    // CONSULTA O CEP INFORMADO NO VIACEP E PREENCHE AUTOMATICAMENTE O RESTO DO ENDEREÇO
    const handleSearchCep = async () => {
      const cleanCep = (editCompanyCep ?? '').replace(/\D/g, '');

      if(cleanCep.length !== 8){
        setWarnAlert({show: true, title: 'CEP inválido', text: 'Informe um CEP válido com 8 dígitos para realizar a busca automática.'});
        return;
      }

      try{
        setSearchingCep(true);

        const addressData = await getAddressInformations(cleanCep);

        if(!addressData){
          setWarnAlert({show: true, title: 'CEP não encontrado', text: 'Não foi possível localizar um endereço para o CEP informado.'});
          return;
        }

        setEditCompanyState(addressData.state);
        setEditCompanyCity(addressData.city);
        setEditCompanyStreet(addressData.street);
        setEditCompanyDistrict(addressData.district);

      } catch (e) {
        console.error('ERROR - SEARCH CEP FUNCTION:', e);
        setWarnAlert({show: true, title: 'Erro', text: 'Não foi possível consultar o CEP no momento. Tente novamente em instantes.'});

      } finally {
        setSearchingCep(false);
      }
    }




    // FUNÇÃO QUE SALVA OS DADOS DO CLIENTE
    const handleSaveData = async () => {
      try{
        setLoading(true);


        const res = await axios.post(`/admin/companies/edit`, {
          data: {
            id: props.data.id,
            name: editNomeFantasia,
            razao_social: editRazaoSocial,
            document: editCompanyDocument,
            email: editCompanyEmail,
            phone: editCompanyPhone,
            fiscal: {
              nfeNumber: editNfeNumber,
              nfceNumber: editNfceNumber,
              issueSeries: editIssueSeries,
              stateRegistration: editStateRegistration,
              emissionEnv: String(editEmissionEnv ?? '2'),
              crt: editCrt,
              rt: CRT_TO_RT[editCrt],
              icms: editIcms === '' ? null : editIcms,
            },
            address: {
              cep: editCompanyCep,
              state: editCompanyState,
              city: editCompanyCity,
              street: editCompanyStreet,
              district: editCompanyDistrict,
              number: editCompanyNumber,
              complement: editCompanyComplement,
              latitude: editLatitude,
              longitude: editLongitude,
              radius: editRadius
            },
            payment_control: {
              cost: normalizeValues(editPaymentPrice ? normalizeValues(editPaymentPrice) : '0'),
              payment_day: editPaymentDay ?? null,
              next_payment: editNextPayment || null,
            },
            permissions: {
              use_invoice: checkPrintNfe,
              use_smartmenu: checkUseSmartmenu,
              use_ifood: checkUseIfood,
              use_stock: checkUseStock,
            }
          }
        })

        if(res.status == 200){
          props.returnAction();
        }

      } catch (e) {
        console.error('ERROR - SAVE EDITED DATA FUNCTION:', e);
        setWarnAlert({show: true, title: 'Erro', text: e?.response?.data?.error ?? 'Houve um erro ao salvar os dados do cliente. Tente novamente em instantes!'});

      } finally {
        setLoading(false);
      }
    }





    // COMPONENT ===================================================>

    return props.view && (

        <div id={styles.editInformationsArea}>

          <div className={styles.editInformationsOverflow} />

          <div className={styles.editBox}>

            {/* BOX HEADER */}
            <div className={styles.editBoxHeader}>

              <div className={styles.boxHeaderContainer}>
                <h1 className={styles.titleBox}>{props.data.name}</h1>

                <button className={styles.closeBtn} onClick={() => props.close()}>
                  <IoIosCloseCircle size={30} color='#fff'/>
                </button>

              </div>
            </div>



            {/* BOX CONTAINER AREA */}

            <div id={styles.boxContainer}>

              <div className={styles.form}>

                <div className={styles.formArea}>

                  <p className={styles.titleInformations} style={{marginBottom: 0}}>Dados da empresa:</p>

                  <div className={styles.rowInputsArea}>
                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='nome-fantasia' className={styles.labelInput}>Nome fantasia:</label>
                      <input id='nome-fantasia' className={styles.inputConfig} name="nome-fantasia" type="text" value={editNomeFantasia ?? ''} onChange={(event) => setEditNomeFantasia(event.target.value)} placeholder={props.data.name}/>
                    </div>

                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='razao-social' className={styles.labelInput}>Razão social:</label>
                      <input id='razao-social' className={styles.inputConfig} name="razao-social" type="text" value={editRazaoSocial ?? ''} onChange={(event) => setEditRazaoSocial(event.target.value)} placeholder={props.data.name}/>
                    </div>

                  </div>

                  <div className={styles.rowInputsArea}>
                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='company-document' className={styles.labelInput}>CPF/CNPJ:</label>
                      <input id='company-document' className={styles.inputConfig} name="company-document" type="text" value={editCompanyDocument ?? ''} onChange={(e) => setEditCompanyDocument(e.target.value)} placeholder={props.data.document}/>
                    </div>

                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='company-email' className={styles.labelInput}>Email:</label>
                      <input id='company-email' className={styles.inputConfig} name="company-email" type="email" value={editCompanyEmail ?? ''} onChange={(e) => setEditCompanyEmail(e.target.value)} placeholder={props.data.email}/>
                    </div>
                  </div>

                  <div className={styles.rowInputsArea}>
                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='company-phone' className={styles.labelInput}>Telefone:</label>
                      <InputMask
                        id='company-phone'
                        className={styles.inputConfig}
                        name="company-phone"
                        type="text"
                        mask={editCompanyPhone.replace('(', '').replace(')', '').replace('-', '').length < 11 ? "(__) ____-____)" : "(__) _____-____)"}
                        replacement={{ _: /\d/ }}
                        placeholder={props.data.phone ?? '(99) 99999-9999'}
                        value={editCompanyPhone ?? ''}
                        onChange={({ target: { value } }) => setEditCompanyPhone(value)}
                    />
                    </div>
                  </div>
                </div>

                <div className={styles.formArea}>

                  <p className={styles.titleInformations} style={{marginBottom: 0}}>Dados fiscais:</p>

                  <div className={styles.rowInputsArea}>
                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='issue-series' className={styles.labelInput}>Série de nota:</label>
                      <input id='issue-series' className={styles.inputConfig} name="issue-series" type="text" value={editIssueSeries ?? ''} onChange={({target: {value}}) => setEditIssueSeries(value)} placeholder={props.data.issue_series}/>
                    </div>

                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='state-registration' className={styles.labelInput}>Inscrição estadual:</label>
                      <input id='state-registration' className={styles.inputConfig} name="state-registration" type="text" value={editStateRegistration ?? ''} onChange={(event) => setEditStateRegistration(event.target.value)} placeholder={props.data.state_registration}/>
                    </div>
                  </div>

                  <div className={styles.rowInputsArea}>
                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='nfe-number' className={styles.labelInput}>Número de NF-e:</label>
                      <input id='nfe-number' className={styles.inputConfig} name="nfe-number" type="text" value={editNfeNumber ?? ''} onChange={({target: {value}}) => setEditNfeNumber(value)} placeholder={props.data.issue_number}/>
                    </div>

                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='nfce-number' className={styles.labelInput}>Número de NFC-e:</label>
                      <input id='nfce-number' className={styles.inputConfig} name="nfce-number" type="text" value={editNfceNumber ?? ''} onChange={({target: {value}}) => setEditNfceNumber(value)} placeholder={props.data.issue_series}/>
                    </div>
                  </div>

                  <div className={styles.rowInputsArea}>
                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='icms' className={styles.labelInput}>ICMS (%):</label>
                      <input id='icms' className={styles.inputConfig} name="icms" type="text" value={editIcms ?? ''} onChange={({target: {value}}) => setEditIcms(value)} placeholder="Ex: 18.00"/>
                    </div>

                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='emission-env' className={styles.labelInput}>Ambiente de emissão:</label>

                      <select
                        id='emission-env'
                        className={styles.inputConfig}
                        value={editEmissionEnv}
                        onChange={({target: {value}}) => setEditEmissionEnv(value)}
                      >
                        <option value='1'>Produção (1)</option>
                        <option value='2'>Homologação (2)</option>
                      </select>
                    </div>
                  </div>


                  <div className={styles.inputAreaConfig}>
                    <label htmlFor='crt' className={styles.labelInput}>CRT (Regime Tributário):</label>

                    <select
                      id='crt'
                      className={styles.inputConfig}
                      value={editCrt}
                      onChange={({target: {value}}) => setEditCrt(value)}
                    >
                      <option value='1'>1 - Simples Nacional</option>
                      <option value='2'>2 - Simples Nacional (excesso de sublimite)</option>
                      <option value='3'>3 - Regime Normal</option>
                      <option value='4'>4 - MEI (Microempreendedor Individual)</option>
                    </select>
                  </div>
                </div>

                <div className={styles.formArea}>

                  <p className={styles.titleInformations} style={{marginBottom: 0}}>Endereço de cobrança:</p>

                  <div className={styles.rowInputsArea}>

                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='company-cep' className={styles.labelInput}>CEP:</label>
                      <div className={styles.inputWithButton}>
                        <input id='company-cep' className={styles.inputConfig} style={{marginTop: 0}} name="company-cep" type="text" value={editCompanyCep ?? ''} onChange={(e) => setEditCompanyCep(e.target.value)} placeholder={props.data.address.cep}/>
                        <button type="button" className={styles.searchCepBtn} onClick={() => handleSearchCep()} disabled={searchingCep} title="Buscar endereço pelo CEP">
                          {searchingCep ? (
                            <Oval visible={true} height="16" width="16" color="#fff" ariaLabel="oval-loading"/>
                          ) : (
                            <FiSearch size={16} color="#fff"/>
                          )}
                        </button>
                      </div>
                    </div>

                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='company-state' className={styles.labelInput}>Estado:</label>
                      <input id='company-state' className={styles.inputConfig} name="company-state" type="text" value={editCompanyState ?? ''} onChange={(e) => setEditCompanyState(e.target.value)} placeholder={props.data.address.state}/>
                    </div>

                  </div>

                  <div className={styles.rowInputsArea}>
                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='company-city' className={styles.labelInput}>Cidade:</label>
                      <input id='company-city' className={styles.inputConfig} name="company-city" type="text" value={editCompanyCity ?? ''} onChange={(e) => setEditCompanyCity(e.target.value)} placeholder={props.data.address.city}/>
                    </div>

                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='company-street' className={styles.labelInput}>Rua:</label>
                      <input id='company-street' className={styles.inputConfig} name="company-street" type="text" value={editCompanyStreet ?? ''} onChange={(e) => setEditCompanyStreet(e.target.value)} placeholder={props.data.address.street}/>
                    </div>

                  </div>

                  <div className={styles.rowInputsArea}>
                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='company-district' className={styles.labelInput}>Bairro:</label>
                      <input id='company-district' className={styles.inputConfig} name="company-district" type="text" value={editCompanyDistrict ?? ''} onChange={(e) => setEditCompanyDistrict(e.target.value)} placeholder={props.data.address.district}/>
                    </div>

                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='company-number' className={styles.labelInput}>Número:</label>
                      <input id='company-number' className={styles.inputConfig} name="company-number" type="text" value={editCompanyNumber ?? ''} onChange={(e) => setEditCompanyNumber(e.target.value)} placeholder={props.data.address.number}/>
                    </div>

                  </div>

                  <div className={styles.inputAreaConfig} style={{width: '100%', maxWidth: '95%'}}>
                    <label htmlFor='company-complement' className={styles.labelInput}>Complemento:</label>
                    <input
                      id='company-complement'
                      className={styles.inputConfig}
                      style={{width: '100%', marginRight: 0}}
                      name="company-complement"
                      type="text"
                      value={editCompanyComplement ?? ''}
                      onChange={(e) => setEditCompanyComplement(e.target.value)}
                      placeholder={props.data.address.complement ?? 'Complemento de endereço do cliente.'}
                    />
                  </div>

                  <div className={styles.rowInputsArea}>
                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='latitude' className={styles.labelInput}>Latitude:</label>
                      <input className={styles.inputConfig} name="latitude" type="text" value={editLatitude ?? ''} onChange={(e) => setEditLatitude(e.target.value)} placeholder={'Latitude'}/>
                    </div>

                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='longitude' className={styles.labelInput}>Longitude:</label>
                      <input className={styles.inputConfig} name="longitude" type="text" value={editLongitude ?? ''} onChange={(e) => setEditLongitude(e.target.value)} placeholder={'Longitude'}/>
                    </div>
                  </div>

                  <div className={styles.inputAreaConfig}>
                    <label htmlFor='area-radius' className={styles.labelInput}>Raio de atuação:</label>
                    <input className={styles.inputConfig} name="area-radius" type="text" value={editRadius ?? ''} onChange={(e) => setEditRadius(e.target.value)} placeholder={'0'}/>
                  </div>
                </div>

                <div className={styles.formArea}>

                  <p className={styles.titleInformations} style={{marginBottom: 0}}>Dados de mensalidade:</p>

                  <div className={styles.rowInputsArea}>

                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='payment-price' className={styles.labelInput}>Valor / mensalidade:</label>
                      <input
                        id='payment-price'
                        type='text'
                        className={styles.inputConfig}
                        placeholder="R$00,00"
                        value={editPaymentPrice}
                        onChange={({target: {value}}) => formatInputCurrencyValues({ value: value, saveAction: setEditPaymentPrice })}
                      />
                    </div>

                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='payment-day' className={styles.labelInput}>Dia de pagamento:</label>
                      <input
                        className={styles.inputConfig}
                        name="payment-day"
                        type="text"
                        value={editPaymentDay ?? ''}
                        onChange={({target: {value}}) => setEditPaymentDay(value)}
                        placeholder="Melhor dia para pagamento"
                        limit={2}
                      />
                    </div>

                  </div>

                  <div className={styles.rowInputsArea}>
                    <div className={styles.inputAreaConfig}>
                      <label htmlFor='next-payment' className={styles.labelInput}>Próximo pagamento previsto:</label>
                      <input
                        className={styles.inputConfig}
                        name="next-payment"
                        type="date"
                        value={editNextPayment ?? ''}
                        onChange={({target: {value}}) => setEditNextPayment(value)}
                      />
                    </div>
                  </div>

                </div>

                <div className={styles.formArea}>
                  <p className={styles.titleInformations} style={{marginBottom: 0}}>Permissões da empresa:</p>

                  <div className={styles.checkboxArea}>
                    <p className='labelCheckbox'>Emite notas fiscais:</p>
                    <input type='checkbox' className={styles.checkboxConfig} checked={checkPrintNfe} onChange={() => setCheckPrintNfe(!checkPrintNfe)} color="#2eb4f1"/>
                  </div>

                  <div className={styles.checkboxArea}>
                    <p className='labelCheckbox'>Usa smartmenu:</p>
                    <input type='checkbox' className={styles.checkboxConfig} checked={checkUseSmartmenu} onChange={() => setCheckUseSmartmenu(!checkUseSmartmenu)} color="#2eb4f1"/>
                  </div>

                  <div className={styles.checkboxArea}>
                    <p className='labelCheckbox'>Integração com Ifood:</p>
                    <input type='checkbox' className={styles.checkboxConfig} checked={checkUseIfood} onChange={() => setCheckUseIfood(!checkUseIfood)} color="#2eb4f1"/>
                  </div>

                  <div className={styles.checkboxArea}>
                    <p className='labelCheckbox'>Usa estoque:</p>
                    <input type='checkbox' className={styles.checkboxConfig} checked={checkUseStock} onChange={() => setCheckUseStock(!checkUseStock)} color="#2eb4f1"/>
                  </div>

                </div>

              </div>

              <div className={styles.editButtonsArea}>
                <button id={styles.saveDataButton} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}} onClick={() => handleSaveData()}>
                  {loading ? (
                    <Oval
                      visible={true}
                      height="20"
                      width="20"
                      color="#fff"
                      ariaLabel="oval-loading"
                    />
                  ) : (
                    <p id={styles.saveDataBtnText}>Salvar</p>
                  )}
                </button>

                <button id={styles.resetEditDataBtn} onClick={() => handleSetEditValues()}>
                  <GrPowerReset size={24} color={'#fff'}/>
                </button>
              </div>

            </div>

          </div>


          <BoxAlert
            show={warnAlert.show}
            title={warnAlert.title}
            text={warnAlert.text}
            confirmFunction={() => setWarnAlert({show: false, title: null, text: null})}
          />

        </div>
    )
}
